module.exports = __webpack_public_path__ + "static/media/MountainPeakDestroyedST02EXTA0008_design_clean_v002.da4c4b6d.png";